import ShortsPage from "@/screens/Shorts";
import PageLayout from "@/screens/Layout/PageLayout";
import useIsMobile from "@/hooks/useIsMobile";

export default function Shorts({
  shortsVideoListData = null,
  latestVideoData = null,
  latestStoryData = null,
}) {
  // console.log("first", shortsVideoListData);
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        // rightSideBarData={shortsVideoListData}
        isMobileDevice={isMobileDevice}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <ShortsPage
          shortsVideoListData={shortsVideoListData}
          isMobileDevice={isMobileDevice}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    const { getShortsVideoList } = await import("@/handlers/shorts");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let shortVideoListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "shortvideodatalisting", page: page, display: 12 },
    });
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [shortsVideoListData, { latestStoryData, latestVideoData }] =
      await Promise.all([
        fetchRedisWrapper(shortVideoListRedisKey, () =>
          getShortsVideoList({ page: page, display: 12 })
        ),
        fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      ]);

    // if (!shortVideoData || Object.keys(shortVideoData).length === 0) {
    //   return {
    //     notFound: true,
    //   };
    // }

    let headerCache = shortsVideoListData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);
    return {
      props: {
        shortsVideoListData,
        latestVideoData,
        latestStoryData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
